import React from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { connect } from 'react-redux';

import BodyText from '../../../ui/BodyText';
import Image from '../../../shared/Image';
import instagramIcon from '../../../../../images/icons/icon-instagram.svg';
import proNotifications from '../../../../modules/proNotifications';
import withStore from '../../../withStore';

import './InstaSyncNotification.module.scss';
import { PRO_IMAGE_LIST } from '../../../../route-names';

/**
 * Add Instagram sync notification
 */
function InstaSyncNotification({ notification, linkTo }) {
  const routeToImageGallery = () => {
    proNotifications.trackNotificationClick(notification);
    linkTo(PRO_IMAGE_LIST, {
      providerId: notification.provider_id,
      modalId: 'pro-add-photo',
    });
  };

  return (
    <TouchableOpacity onClick={routeToImageGallery}>
      <View styleName="notification-container">
        <View styleName="icon">
          <Image
            source={{
              uri: instagramIcon,
              width: 30,
              height: 30,
              resizeMode: 'center',
            }}
          />
        </View>
        <View styleName="notification-body">
          <View styleName="badge-container">
            <BodyText appearance="smaller" styleName="badge-text">NEW!</BodyText>
          </View>
          <View styleName="short-block">
            <BodyText styleName="notification-text">
              New clients are looking for your latest work when considering booking.
            </BodyText>
            <View styleName="notification-indent">
              <BodyText>
                Sync your Instagram photos, so your profile is always up to date.
              </BodyText>
            </View>
            <BodyText appearance="small" styleName="notification-date">
              {proNotifications.getFromNowDisplay(notification.creation_time)}
            </BodyText>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
}

InstaSyncNotification.propTypes = {
  /** Pass route and params for navigation */
  linkTo: PropTypes.func.isRequired,
  /** notification object from feed */
  notification: PropTypes.object,
};

InstaSyncNotification.defaultProps = {
  notification: {},
};

const mapDispatchToProps = dispatch => ({
  linkTo: (route, params, notify = true) => dispatch.route.go({
    route,
    params,
    notify,
  }),
});

export default withStore(connect(null, mapDispatchToProps)(InstaSyncNotification));
